import { takeLatest, put } from 'redux-saga/effects';
import { API, STATUS } from '@vezeeta/web-utils';
import Cookies from 'js-cookie';
import CoustomUrls from 'configs/urls';
import { REWARDS } from '../actions/rewardsCampaigns';
import formatRewardsPayload from 'views/rewards/utils/formatRewardsPayload';
import { buildQueryString } from 'views/rewards/utils/rewardsFormatters';

const authHeaders = () => [
  {
    key: 'AuthenticationKey',
    value: process.env.REACT_APP_VOUCHERS_AUTHENTICATIONKEY
  }
];

const parseError = response => {
  if (!response) {
    return 'Request failed';
  }
  if (response.detail) {
    return response.detail;
  }
  if (response.message) {
    return response.message;
  }
  if (typeof response === 'string') {
    return response;
  }
  return 'Request failed';
};

function* fetchListSaga({ filters }) {
  const api = new API();
  const query = buildQueryString({
    pageNumber: filters.pageNumber || 1,
    pageSize: filters.pageSize || 20,
    campaignType: filters.campaignType,
    status: filters.status,
    productKey: filters.productKey,
    fundingSource: filters.fundingSource
  });
  const url = `${CoustomUrls.rewards.campaigns}${query}`;
  const res = yield api.get(url, authHeaders(), false);

  if (STATUS.isSuccess(res.status)) {
    const data = res.response;
    yield put({
      type: REWARDS.FETCH_LIST.SUCCESS,
      items: data.Items || [],
      totalCount: data.TotalCount || 0,
      pageNumber: data.PageNumber || 1,
      pageSize: data.PageSize || 20
    });
  } else {
    yield put({
      type: REWARDS.FETCH_LIST.FAIL,
      error: parseError(res.response)
    });
  }
}

function* fetchDetailSaga({ id }) {
  const api = new API();
  const res = yield api.get(
    CoustomUrls.rewards.campaignById(id),
    authHeaders(),
    false
  );

  if (STATUS.isSuccess(res.status)) {
    yield put({
      type: REWARDS.FETCH_DETAIL.SUCCESS,
      detail: res.response
    });
  } else {
    yield put({
      type: REWARDS.FETCH_DETAIL.FAIL,
      error: parseError(res.response)
    });
  }
}

function* createSaga({ form, userKey }) {
  const api = new API();
  const body = formatRewardsPayload(form);
  const key = userKey || Cookies.get('AUTH_TOKEN');
  const headers = [
    ...authHeaders(),
    { key: 'userKey', value: key || '' }
  ];
  const res = yield api.post(
    CoustomUrls.rewards.campaigns,
    body,
    headers,
    false
  );

  if (STATUS.isSuccess(res.status)) {
    yield put({
      type: REWARDS.CREATE.SUCCESS,
      campaign: res.response
    });
  } else {
    yield put({
      type: REWARDS.CREATE.FAIL,
      error: parseError(res.response),
      message: parseError(res.response)
    });
  }
}

function* updateStatusSaga({ id, status }) {
  const api = new API();
  const res = yield api.makeRequest(
    'post',
    { Status: status },
    CoustomUrls.rewards.campaignStatus(id),
    authHeaders(),
    false
  );

  if (STATUS.isSuccess(res.status)) {
    yield put({
      type: REWARDS.UPDATE_STATUS.SUCCESS,
      detail: res.response,
      message: `Campaign status updated to ${res.response.Status || status}`
    });
    yield put({
      type: REWARDS.FETCH_DETAIL.LOAD,
      id
    });
  } else {
    yield put({
      type: REWARDS.UPDATE_STATUS.FAIL,
      error: parseError(res.response),
      message: parseError(res.response)
    });
  }
}

export default function* rewardsCampaigns() {
  yield takeLatest(REWARDS.FETCH_LIST.LOAD, fetchListSaga);
  yield takeLatest(REWARDS.FETCH_DETAIL.LOAD, fetchDetailSaga);
  yield takeLatest(REWARDS.CREATE.LOAD, createSaga);
  yield takeLatest(REWARDS.UPDATE_STATUS.LOAD, updateStatusSaga);
}
